import { RangeField } from './range-field.model';

export class ExportRequest {
  constructor(
    public years: number[],
    public ages: RangeField[],
    public spendings: RangeField[],
    public states: string[] = [],
    public genders?: string[],
    public groupBy: string[] = [],
    public include: string[] = [],
    public valueType: string | undefined = undefined,
    public categories: string[] | undefined = undefined,
    public subnationalCode?: string,
    public cityIds?: string[],
    public generations?: string[],
    public addWorld: boolean = false
  ) {}
}
